module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921112649_T.2fdf5937.jpg";